import { render, staticRenderFns } from "./PoliticasPrivacidade.vue?vue&type=template&id=2e0af69e&scoped=true"
import script from "./PoliticasPrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticasPrivacidade.vue?vue&type=script&lang=js"
import style0 from "./PoliticasPrivacidade.vue?vue&type=style&index=0&id=2e0af69e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0af69e",
  null
  
)

export default component.exports